import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UserProfileService } from '../../core/user-profile/user-profile.service';
import { UserImage } from '../../shared/models/user-image.model';
import { ProfileImageLoad } from './user-profile.actions';

export interface UserProfileStateModel {
    loading: boolean;
    data: UserImage;
    error: any;
}

@State<UserProfileStateModel>({
    name: 'UserProfile',
    defaults: {
        loading: false,
        data: null,
        error: null
    }
})

@Injectable()
export class UserProfileState {

    constructor(
        private profileService: UserProfileService
    ) { }

    /**
     *
     *
     * @name getLoader
     * @description This method is used to select loading state
     * @static
     * @param state
     * @returns
     * @memberof UserProfileState
     */
    @Selector()
    static getLoader(state: UserProfileStateModel) {
        return state.loading;
    }

    /**
     *
     *
     * @name getUserProfileImage
     * @description This method is used to select profile image data from state
     * @static
     * @param state
     * @memberof UserProfileState
     */
    @Selector()
    static getUserProfileImage(state: UserProfileStateModel) {
        return state.data;
    }

    /**
     *
     *
     * @description to fetch the profile image
     * @param ctx
     * @param action
     * @return Observable<any>
     * @memberof UserProfileState
     */
    @Action(ProfileImageLoad)
    loadProfileImage(ctx: StateContext<UserProfileStateModel>, action: ProfileImageLoad): Observable<UserImage> {
        const state = ctx.getState();
        if (state && (state.data || state.loading)) {
            return of(state.data);
        } else {
            this.startLoader(ctx);
            return this.profileService.retrieveABOImage(action.payload.aboNum, action.payload.partyId).pipe(
                tap(image => {
                    const aboImageState = ctx.getState();
                    ctx.setState({
                        ...aboImageState,
                        loading: false,
                        data: image
                    });
                }));
        }

    }

    /**
     *
     *
     * @name startLoader
     * @description This method is used to patch state loading
     * @param ctx
     * @memberof UserProfileState
     */
    startLoader(ctx: StateContext<UserProfileStateModel>) {
        ctx.patchState({
            loading: true
        });
    }


}
